export const KYC_STATUS_LABEL: Record<string, string> = {
  not_started: "Не начато",
  files_uploading: "Загрузка документов",
  pending_review: "На проверке",
  approved: "Одобрено",
  rejected: "Отклонено",
  ocr_failed: "Ошибка распознавания",
  ocr_incomplete: "Данные неполные",
};

export function kycStatusLabel(s?: string | null): string {
  if (!s) return "—";
  return KYC_STATUS_LABEL[s] ?? s;
}

export function kycAnswerLabel(a?: string | null): string | null {
  if (!a) return null;
  if (a === "GREEN") return "Одобрено";
  if (a === "RED") return "Отклонено";
  return a;
}

export function kycModeLabel(m?: string | null): string {
  if (m === "manual") return "Ручной";
  if (m === "sumsub") return "Sumsub";
  return m ?? "—";
}

// Подписи распознанных паспортных полей (порядок задаёт вывод)
export const PASSPORT_FIELDS: { key: string; label: string }[] = [
  { key: "full_name", label: "ФИО" },
  { key: "dob", label: "Дата рождения" },
  { key: "gender", label: "Пол" },
  { key: "pob", label: "Место рождения" },
  { key: "series", label: "Серия" },
  { key: "number", label: "Номер" },
  { key: "issued_by", label: "Кем выдан" },
  { key: "issued_at", label: "Дата выдачи" },
  { key: "division_code", label: "Код подразделения" },
];

export function passportValue(key: string, v: unknown): string {
  if (v === null || v === undefined || v === "") return "—";
  if (key === "gender") return v === "M" ? "Муж." : v === "F" ? "Жен." : String(v);
  return typeof v === "object" ? JSON.stringify(v) : String(v);
}
